import CityService from "src/services/CityService";
import ModuleCreator from "src/store/ModuleCreator";

export const types = {};
export const params = {
	name:"",

};

/**
@namespace
@property  {object} module,
@property  {object} module.state,
@property  {object} modules.city,
@property  {array}  modules.cities
**/

const module = {
	state: {},
	mutations: {},
	getters: {},
	actions: {},
	types: types
};
export default ModuleCreator({ name:"city", plural: "cities" }, CityService, module, types ,params);
